import React from 'react'
import Footer from './Footer'

export default function Refund() {
  return (
    <div>
       
       <div class="refund-container">
        <h1 class="refund-title">Refund Policy</h1>
        
        <p class="refund-text">At Insurance Advisors, we are committed to ensuring clarity and transparency for our clients. Please note that all insurance policies purchased through our platform are typically non-refundable. We encourage clients to carefully review their selected policy and confirm it aligns with their needs before making a purchase.</p>

        <h2 class="refund-heading">Non-Refundable Policy Details</h2>
        <p class="refund-text">Once a policy has been purchased, it is generally non-refundable due to the nature of insurance coverage and the terms set by the insurance providers. This policy ensures that all clients are treated equally and helps us maintain a consistent approach across all transactions.</p>

        <h2 class="refund-heading">Consideration Before Purchase</h2>
        <p class="refund-text">We strongly advise clients to thoroughly review their chosen insurance policy's terms and conditions before purchasing. This includes understanding the scope of coverage, exclusions, and any specific clauses related to claims. Our team is always available to answer questions and provide guidance to help you make an informed decision.</p>

        <h2 class="refund-heading">Exceptional Cases</h2>
        <p class="refund-text">While our general policy is non-refundable, we understand that certain exceptional situations may arise. In some cases, partial refunds may be considered, but this depends entirely on the insurance provider’s discretion and policy terms. Any partial refunds, if applicable, may be subject to administrative fees.</p>

        <h2 class="refund-heading">Customer Support and Assistance</h2>
        <p class="refund-text">Our team is here to support you with any questions or concerns regarding your policy. If you have a query about coverage details or the refund policy, please reach out to us before finalizing your purchase. We aim to provide you with clear and comprehensive information to ensure your satisfaction and understanding.</p>

        <h2 class="refund-heading">Contact Information</h2>
        <p class="refund-text">For any inquiries related to our Refund Policy or if you need assistance with your insurance policy, please contact our customer service team. We are dedicated to providing responsive support and ensuring that you have a positive experience with Insurance Advisors.</p>
    </div>

    <div>
        <Footer></Footer>
    </div>
    </div>
  )
}
